
import Button from "../../../../../../../shared/lib/html5-software-library/src/ranj/components/buttons/Button";
import DialogOptionButton from "../../../../../../../shared/lib/html5-software-library/src/ranj/components/buttons/DialogOptionButton";
import ContentTypes from "../../../../../../../shared/lib/html5-software-library/src/ranj/eng/content/ContentTypes";
import AppModel from "../../../../../../../shared/src/ranj/app/core/AppModel";
import SoundType from "../../../../../../../shared/src/ranj/app/sound/SoundType";
import SkinKeys from "../../../../../../../shared/src/ranj/app/ui/SkinKeys";
import { AbstractDialogPlayerOptionsMediator } from "./AbstractDialogPlayerOptionsMediator";
import DialogOptionHelper from "./DialogOptionHelper";

/**
* DialogPlayerOptionsFixedButtonsMediator.js
* 
* Created on 8-okt-2013, 15:34:40
*
* @author Ivo Swartjes for Ranj
**/
export default class DialogPlayerOptionsFixedButtonsMediator extends AbstractDialogPlayerOptionsMediator {
    constructor(target, dispatcher, soundManager, mediatorManager) {
        super();

        this._skin = target;

        this._optionButtonDict = {};
        this._buttonArray = [];
        this._soundManager = soundManager;
        this._mediatorManager = mediatorManager;

        this._dialogAnswerTimerMediator;
        this._speedFactor = AppModel.speedFactor;
    }

    initialize() {
        this._handleOptionButtonClickBound = this._onOptionButtonClicked.bind(this);

        this._skin.gotoAndStop(0);

        for (let i = 1; i <= 9; i++) {
            const buttonSkin = this._skin[`dialogOptionButton${i}`];
            if (!buttonSkin) {
                break;
            }
            buttonSkin.yOrig = buttonSkin.y;
            buttonSkin.scaleOrig = buttonSkin.scaleY;
            const button = new Button(buttonSkin);
            this._buttonArray.push(button);
        }

        this._clearOptionButtons();

        this.setDialogPlayer(this._skin["dialogPlayer"]);

    }

    destroy() {
        this._optionButtonDict = null;
        this._clearProcessDialogOptionsTimeout();
        super.destroy();
    }

    // ------------------------------------------
    // 			Dialog displaying
    // ------------------------------------------

    _onOptionButtonClicked({ currentTarget }) {
        const option = this._optionButtonDict[currentTarget.skin.id];
        this._soundManager.playSound(SoundType.SOUND_CLICK);

        let delay = 0;
        const buttons = this._buttonArray.slice(0).reverse();
        buttons.forEach(button => {
            button.setEnabled(false);
            this._animateOptionButtonOut(button.skin, delay += 50);
        });

        // Tell delegate that this option was chosen.
        setTimeout(() => {
            this.getDialogPlayer().optionChosen(option);
        }, 200);
    }

    _clearOptionButtons() {
        this._buttonArray.forEach(button => {
            button.removeEventListener("click", this._handleOptionButtonClickBound);
            button.skin.visible = false;
            delete this._optionButtonDict[button.skin.id];
        });
    }

    _handleDialogOptionsChanged() {
        this._clearProcessDialogOptionsTimeout();
        this._timeoutProcessDialogOptions = setTimeout(this._processDialogOptions.bind(this), 50);

    }
    _clearProcessDialogOptionsTimeout() {
        if (this._timeoutProcessDialogOptions != null) {
            clearTimeout(this._timeoutProcessDialogOptions);
            this._timeoutProcessDialogOptions = null;
        }
    }

    _processDialogOptions() {
        // Clear & hide all dialog buttons
        this._clearOptionButtons();

        // Show relevant dialog buttons
        const currentOptions = this.getDialogPlayer().getCurrentOptions().slice(0);
        if (currentOptions.length > this._buttonArray.length) {
            throw new Error(`Number of options (${currentOptions.length}) exceeds number of option buttons (${this._buttonArray.length}).`);
        }
        currentOptions.reverse();

        let delay = 0;
        for (let i = 0; i < currentOptions.length; i++) {
            const option = currentOptions[i];
            if (DialogOptionHelper.isContinueOption(option)) {
                continue;
            }
            const btn = this._buttonArray[i];// Filter out "special" options
            this._optionButtonDict[btn.skin.id] = option;

            let dialogContentPackage = null;
            if (option.getData() !== null) {
                dialogContentPackage = option.getData().getData();
            }
            if (dialogContentPackage !== null) {
                const content = dialogContentPackage.content;
                if (content !== null) {
                    let label;
                    switch (content.getType()) {
                        case ContentTypes.TYPE_TEXT:
                            label = content.getText();
                            break;
                        case ContentTypes.TYPE_KEY_MOMENT_CHOICE:
                            label = content.getChoice();
                            break;
                    }
                    if (label === null || label === "") label = "<TEXT NOT FOUND>";
                    btn.setCenteredLabel(label);
                    btn.setEnabled(true);
                }
            }

            btn.removeEventListener("click", this._handleOptionButtonClickBound);
            btn.addEventListener("click", this._handleOptionButtonClickBound);
            this._animateOptionButtonIn(btn.skin, delay += 100);
        }
    }

    _animateOptionButtonIn(target, delay) {
        target.visible = true;
        target.alpha = 0;
        target.scaleX = target.scaleY = .1 * target.scaleOrig;
        createjs.Tween.get(target)
            .wait(delay / this._speedFactor)
            .to({ alpha: 1, scaleX: target.scaleOrig, scaleY: target.scaleOrig }, 200 / this._speedFactor, createjs.Ease.backOut);
    }

    _animateOptionButtonOut(target, delay) {
        const scale = .1 * target.scaleOrig;
        createjs.Tween.get(target)
            .wait(delay / this._speedFactor)
            .to({ alpha: 0, scaleX: scale, scaleY: scale }, 100 / this._speedFactor, createjs.Ease.quadOut)
            .to({ visible: false }, 0);
    }

    _handleDialogOptionChosen() {
    }
}


